import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { announcements as announcementsApi } from 'redux/modules/api'
import updateSchema from '../../../../models/announcements/updateSchema'


function decorator() {
  return ComposedComponent => {
    @connect(({ api }) => ({
      announcements: api.announcements
    }), { ...announcementsApi })

    class Announcements extends Component {
      static propTypes = {
        announcements: PropTypes.object,
        getCurrentAnnouncementByName: PropTypes.func,
        getCurrentAnnouncement: PropTypes.func,
        updateAnnouncement: PropTypes.func
      }

      componentDidMount() {
        const { announcements, getCurrentAnnouncement } = this.props

        !(announcements.loading || announcements.loaded) && getCurrentAnnouncement()
      }

      handleUpdateAnnouncement = (id, fields) => {
        const data = updateSchema(fields)

        this.props.updateAnnouncement(id, data).then(() => {
          this.props.notification('Announcement was updated', {
            status: 'success',
            intlKey: 'notifications.announcement_was_updated'
          })
          this.props.getCurrentAnnouncement()
        }).catch(this.handleError)

      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            onUpdateAnnouncement={this.handleUpdateAnnouncement}
          />
        )
      }
    }
    return Announcements
  }
}

export default decorator

